import { Card, CardContent } from "@/components/ui/card";

import { type PlanPhase, placeholderNote } from "./plan-tabs";

/**
 * 后续期菜单项的占位页（PR0 新写）：页头由路由外壳出（标题 ＋ 一句话），这里只放一块置灰说明。
 * 不放按钮、不放假数据（plan-page-design ref 03 §1「菜单占位」，D-27）。说明文字按期次给（`placeholderNote`）。
 */
export function PlaceholderPage({ phase }: { phase: PlanPhase }) {
	return (
		<Card className="bg-surface-subtle" data-testid="plan-block-placeholder">
			<CardContent className="p-6">
				<p className="text-sm text-text-muted" data-testid="plan-placeholder-note">
					{placeholderNote(phase)}
				</p>
			</CardContent>
		</Card>
	);
}
